import StringUtils from "./stringUtils";
export default class Formatter {
    static formatUserRole(role) {
        switch (role) {
            case "staff":
                return "Administrator";
            case "coach":
                return "Coach";
            case "member":
                return "User";
            default:
                return "Unknown";
        }
    }
    static formatUserStatus(status) {
        switch (status) {
            case "invited":
                return "Invited";
            case "active":
                return "Active";
            case "disabled":
                return "Disabled";
            default:
                return "Unknown";
        }
    }
    static formatTrainingExtraTag(extra) {
        return `[${extra}]`;
    }
    static formatTrainingContent(training) {
        let content = training.content || "";
        this.trainingExtras.forEach(it => {
            const extra = training[`extra_${it}`];
            if (StringUtils.isNotBlank(extra)) {
                content = `${content}\n\n${this.formatTrainingExtraTag(it)}\n${extra}`;
            }
        });
        return content;
    }
    static formatTaskError(error) {
        let formattedError;
        switch (error) {
            case 'GraphQL error: Uniqueness violation. duplicate key value violates unique constraint "users_email_key"':
                formattedError =
                    "This email is already associated to an existing user (which can be active, invited or disabled).";
                break;
        }
        return formattedError || error;
    }
    static formatBoards(boards) {
        return boards.map(it => it.level).join(", ");
    }
}
Formatter.trainingExtras = ["strength", "aerobic", "gym", "double"];
